webpackJsonp([128],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__langs_json__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__langs_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__langs_json__);






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var defaultLang = {};

__WEBPACK_IMPORTED_MODULE_4__langs_json___default.a.langs.forEach(function (item) {
  if (item.value === __WEBPACK_IMPORTED_MODULE_4__langs_json___default.a.default) {
    defaultLang = item;
  }
});

var route = {
  '/': {
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(70)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    default_lang: defaultLang,
    langs: __WEBPACK_IMPORTED_MODULE_4__langs_json___default.a.langs,
    title: '选择语言'
  },
  '/zh-cn2': {
    title: '概述',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(165)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/repositories': {
    title: '子项目',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(189)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/quickstart': {
    title: '快速上手',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(186)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/toast': {
    title: 'Toast',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(196)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/indicator': {
    title: 'Indicator',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(176)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/loadmore': {
    title: 'Loadmore',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(179)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/infinite-scroll': {
    title: 'Infinite scroll',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(177)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/message-box': {
    title: 'Message box',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(180)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/action-sheet': {
    title: 'Action sheet',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(166)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/popup': {
    title: 'Popup',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(184)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/swipe': {
    title: 'Swipe',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/lazyload': {
    title: 'Lazy load',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(178)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/range': {
    title: 'Range',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(188)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/progress': {
    title: 'Progress',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/picker': {
    title: 'Picker',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/datetime-picker': {
    title: 'Datetime Picker',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(172)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/index-list': {
    title: 'Index List',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(175)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/palette-button': {
    title: 'Palette Button (2.0)',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(182)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/header': {
    title: 'Header',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(174)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/tabbar': {
    title: 'Tabbar',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(195)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/navbar': {
    title: 'Navbar',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(181)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/button': {
    title: 'Button',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(168)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/cell': {
    title: 'Cell',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(170)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/cell-swipe': {
    title: 'Cell Swipe',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(169)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/spinner': {
    title: 'Spinner',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/tab-container': {
    title: 'TabContainer',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(194)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/search': {
    title: 'Search',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(190)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/switch': {
    title: 'Switch',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(193)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/checklist': {
    title: 'Checklist',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(171)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/radio': {
    title: 'Radio',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(187)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/field': {
    title: 'Field',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(173)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn2/badge': {
    title: 'Badge',
    language: 'zh-cn2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(167)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2': {
    title: '概述',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(102)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/repositories': {
    title: '子项目',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/quickstart': {
    title: '快速上手',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/toast': {
    title: 'Toast',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/indicator': {
    title: 'Indicator',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/loadmore': {
    title: 'Loadmore',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(116)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/infinite-scroll': {
    title: 'Infinite scroll',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(114)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/message-box': {
    title: 'Message box',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(117)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/action-sheet': {
    title: 'Action sheet',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(103)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/popup': {
    title: 'Popup',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/swipe': {
    title: 'Swipe',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/lazyload': {
    title: 'Lazy load',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(115)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/range': {
    title: 'Range',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/progress': {
    title: 'Progress',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/picker': {
    title: 'Picker',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/datetime-picker': {
    title: 'Datetime Picker',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(109)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/index-list': {
    title: 'Index List',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/palette-button': {
    title: 'Palette Button (2.0)',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/header': {
    title: 'Header',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/tabbar': {
    title: 'Tabbar',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/navbar': {
    title: 'Navbar',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(118)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/button': {
    title: 'Button',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/cell': {
    title: 'Cell',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(107)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/cell-swipe': {
    title: 'Cell Swipe',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(106)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/spinner': {
    title: 'Spinner',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/tab-container': {
    title: 'TabContainer',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/search': {
    title: 'Search',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/switch': {
    title: 'Switch',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/checklist': {
    title: 'Checklist',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(108)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/radio': {
    title: 'Radio',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/field': {
    title: 'Field',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(110)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en2/badge': {
    title: 'Badge',
    language: 'en2',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn': {
    title: '概述',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/repositories': {
    title: '子项目',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(157)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/quickstart': {
    title: '快速上手',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/toast': {
    title: 'Toast',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(164)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/indicator': {
    title: 'Indicator',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/loadmore': {
    title: 'Loadmore',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/infinite-scroll': {
    title: 'Infinite scroll',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/message-box': {
    title: 'Message box',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/action-sheet': {
    title: 'Action sheet',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/popup': {
    title: 'Popup',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/swipe': {
    title: 'Swipe',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(160)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/lazyload': {
    title: 'Lazy load',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/range': {
    title: 'Range',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/progress': {
    title: 'Progress',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/picker': {
    title: 'Picker',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/datetime-picker': {
    title: 'Datetime Picker',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/index-list': {
    title: 'Index List',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/header': {
    title: 'Header',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/tabbar': {
    title: 'Tabbar',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(163)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/navbar': {
    title: 'Navbar',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/button': {
    title: 'Button',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/cell': {
    title: 'Cell',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/cell-swipe': {
    title: 'Cell Swipe',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/spinner': {
    title: 'Spinner',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(159)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/tab-container': {
    title: 'TabContainer',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(162)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/search': {
    title: 'Search',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(158)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/switch': {
    title: 'Switch',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(161)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/checklist': {
    title: 'Checklist',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/radio': {
    title: 'Radio',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/field': {
    title: 'Field',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/zh-cn/badge': {
    title: 'Badge',
    language: 'zh-cn',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en': {
    title: '概述',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(71)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/repositories': {
    title: '子项目',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(94)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/quickstart': {
    title: '快速上手',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(91)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/toast': {
    title: 'Toast',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(101)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/indicator': {
    title: 'Indicator',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(82)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/loadmore': {
    title: 'Loadmore',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(85)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/infinite-scroll': {
    title: 'Infinite scroll',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(83)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/message-box': {
    title: 'Message box',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(86)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/action-sheet': {
    title: 'Action sheet',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(72)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/popup': {
    title: 'Popup',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(89)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/swipe': {
    title: 'Swipe',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(97)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/lazyload': {
    title: 'Lazy load',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(84)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/range': {
    title: 'Range',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/progress': {
    title: 'Progress',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(90)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/picker': {
    title: 'Picker',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(88)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/datetime-picker': {
    title: 'Datetime Picker',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(78)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/index-list': {
    title: 'Index List',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(81)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/header': {
    title: 'Header',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(80)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/tabbar': {
    title: 'Tabbar',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(100)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/navbar': {
    title: 'Navbar',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(87)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/button': {
    title: 'Button',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(74)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/cell': {
    title: 'Cell',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(76)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/cell-swipe': {
    title: 'Cell Swipe',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(75)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/spinner': {
    title: 'Spinner',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(96)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/tab-container': {
    title: 'TabContainer',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(99)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/search': {
    title: 'Search',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(95)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/switch': {
    title: 'Switch',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(98)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/checklist': {
    title: 'Checklist',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(77)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/radio': {
    title: 'Radio',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(92)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/field': {
    title: 'Field',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(79)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  '/en/badge': {
    title: 'Badge',
    language: 'en',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(73)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }
};

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: formatRoute(route)
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title || document.title;
  next();
});

function formatRoute(route) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(route).map(function (path) {
    var _route$path = route[path],
        language = _route$path.language,
        title = _route$path.title,
        component = _route$path.component;


    return {
      name: path,
      component: component,
      path: path,
      meta: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, route[path], {
        language: language || defaultLang.value
      })
    };
  });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  "data-v-3456b5e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_phone__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_phone__);





/* harmony default export */ __webpack_exports__["default"] = ({
  watch: {
    '$route.path': function $routePath() {
      var _this = this;

      this.$refs.main.scrollTop = 0;
      setTimeout(function () {
        _this.navbarShow = false;
      }, 200);
    }
  },

  data: function data() {
    return {
      navbarShow: false
    };
  },


  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_navbar___default.a,
    Phone: __WEBPACK_IMPORTED_MODULE_1__components_phone___default.a
  },

  methods: {
    toggleNavbar: function toggleNavbar(event) {
      event.stopPropagation();
      this.navbarShow = !this.navbarShow;
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_config_json__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav_config_json__);




__WEBPACK_IMPORTED_MODULE_0__nav_config_json___default.a.map(function (item) {
  item.visible = true;
  return item;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      navs: __WEBPACK_IMPORTED_MODULE_0__nav_config_json___default.a,
      isZH: /zh/.test(navigator.language)
    };
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'phone',

  computed: {
    routePath: function routePath() {
      return this.$route.path.replace(/^\/(zh-cn|en)2?/, '');
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__route__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sushi_ui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sushi_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sushi_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js_styles_github_gist_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js_styles_github_gist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highlight_js_styles_github_gist_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_style_static_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_style_static_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_style_static_css__);







new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__route__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__app___default.a }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  "data-v-710da4d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(64),
  /* scopeId */
  "data-v-8e24ef92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "row main",
    class: {
      'slide-in-left': _vm.navbarShow
    }
  }, [_c('section', {
    staticClass: "col-2 is-scrollable navbar"
  }, [_c('navbar')], 1), _vm._v(" "), _c('section', {
    ref: "main",
    staticClass: "col-6 is-scrollable content",
    on: {
      "click": function($event) {
        _vm.navbarShow = false
      }
    }
  }, [_c('div', {
    staticClass: "navbar-toggle-container"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    on: {
      "click": _vm.toggleNavbar
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('section', {
    staticClass: "col-4 demo"
  }, [_c('phone')], 1)])
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "nav-link edit-doc-btn",
    attrs: {
      "href": "https://github.com/mint-ui/docs",
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isZH ? '参与文档编辑' : 'Edit Documentation') + "\n      ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "active-class": "is-active",
      "exact": "",
      "to": {
        path: '/' + _vm.$route.meta.language
      }
    }
  }, [_vm._v("Overview")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/' + _vm.$route.meta.language + '/quickstart'
      }
    }
  }, [_vm._v("Quickstart")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "active-class": "is-active",
      "exact": "",
      "to": {
        path: '/' + _vm.$route.meta.language + '/repositories'
      }
    }
  }, [_vm._v("Repositories")])], 1), _vm._v(" "), _vm._l((_vm.navs), function(group) {
    return [_c('li', [_c('a', {
      staticClass: "nav-label",
      attrs: {
        "href": "#"
      },
      domProps: {
        "textContent": _vm._s(group.title)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          group.visible = !group.visible
        }
      }
    })]), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.visible),
        expression: "group.visible"
      }],
      style: ({
        maxHeight: group.list.length * 36 + 'px'
      }),
      attrs: {
        "transition": "slidedown"
      }
    }, _vm._l((group.list), function(item) {
      return _c('li', [_c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": {
            path: '/' + _vm.$route.meta.language + item.path
          },
          "active-class": "is-active"
        },
        domProps: {
          "textContent": _vm._s(item.name)
        }
      })], 1)
    }))]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone"
  }, [_c('iframe', {
    staticClass: "demo-page",
    attrs: {
      "src": '//elemefe.github.io/mint-ui/#' + (_vm.routePath === '/loadmore' ? '/pull-down' : (_vm.routePath === '/repositories' || _vm.routePath === '/quickstart' ? '' : _vm.routePath)),
      "frameborder": "0"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

module.exports = {
	"default": "en2",
	"langs": [
		{
			"value": "zh-cn2",
			"text": "中文（Vue 2.0 版）"
		},
		{
			"value": "en2",
			"text": "English (for Vue 2.0)"
		},
		{
			"value": "zh-cn",
			"text": "中文"
		},
		{
			"value": "en",
			"text": "English"
		}
	]
};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = [
	{
		"title": "JS Components",
		"list": [
			{
				"path": "/toast",
				"name": "Toast"
			},
			{
				"path": "/indicator",
				"name": "Indicator"
			},
			{
				"path": "/loadmore",
				"name": "Loadmore"
			},
			{
				"path": "/infinite-scroll",
				"name": "Infinite scroll"
			},
			{
				"path": "/message-box",
				"name": "Message box"
			},
			{
				"path": "/action-sheet",
				"name": "Action sheet"
			},
			{
				"path": "/popup",
				"name": "Popup"
			},
			{
				"path": "/swipe",
				"name": "Swipe"
			},
			{
				"path": "/lazyload",
				"name": "Lazy load"
			},
			{
				"path": "/range",
				"name": "Range"
			},
			{
				"path": "/progress",
				"name": "Progress"
			},
			{
				"path": "/picker",
				"name": "Picker"
			},
			{
				"path": "/datetime-picker",
				"name": "Datetime Picker"
			},
			{
				"path": "/index-list",
				"name": "Index List"
			},
			{
				"path": "/palette-button",
				"name": "Palette Button (2.0)",
				"only": [
					"zh-cn2",
					"en2"
				]
			}
		]
	},
	{
		"title": "CSS Components",
		"list": [
			{
				"path": "/header",
				"name": "Header"
			},
			{
				"path": "/tabbar",
				"name": "Tabbar"
			},
			{
				"path": "/navbar",
				"name": "Navbar"
			},
			{
				"path": "/button",
				"name": "Button"
			},
			{
				"path": "/cell",
				"name": "Cell"
			},
			{
				"path": "/cell-swipe",
				"name": "Cell Swipe"
			},
			{
				"path": "/spinner",
				"name": "Spinner"
			},
			{
				"path": "/tab-container",
				"name": "TabContainer"
			},
			{
				"path": "/search",
				"name": "Search"
			}
		]
	},
	{
		"title": "Form Components",
		"list": [
			{
				"path": "/switch",
				"name": "Switch"
			},
			{
				"path": "/checklist",
				"name": "Checklist"
			},
			{
				"path": "/radio",
				"name": "Radio"
			},
			{
				"path": "/field",
				"name": "Field"
			},
			{
				"path": "/badge",
				"name": "Badge"
			}
		]
	}
];

/***/ })
],[23]);


// WEBPACK FOOTER //
// static/js/app.c4c707926269a262721f.js